import httpService from "../../utils/httpService"
import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {AppThunk} from "../../rootReducer"
import {ErrorMessage, MotOpportunity} from "./models"
import {getAccessToken, getSelectedRegionId} from "../../utils/common"
import dayjs from "dayjs"
import {AxiosError} from "axios"
import {setToastr} from "../App/appSlice"

type ActivityState = {
    loading: boolean
    showMotOpportunityDialog: boolean
    loadingMotOpportunityDetail: boolean
    motOpportunityDetail: MotOpportunity
    savingMOTOpportunity: boolean
    // showErrorToastr: boolean
    // showSucessToastr: boolean
    // errorMessage: ErrorMessage | null
    motOpportunity: MotOpportunity[]
}
const initialState: ActivityState = {
    loading: false,
    showMotOpportunityDialog: false,
    loadingMotOpportunityDetail: false,
    motOpportunityDetail: {} as MotOpportunity,
    savingMOTOpportunity: false,
    // showSucessToastr: false,
    // showErrorToastr: false,
    // errorMessage: null,
    motOpportunity: [],
}

const activitySlice = createSlice({
    name: "activity",
    initialState,
    reducers: {
        setOpportunityGridLoader(state, action: PayloadAction<boolean>) {
            state.loading = action.payload
        },
        getMotOpportunityDetail(state, action: PayloadAction<MotOpportunity[]>) {
            state.motOpportunity = action.payload
        },
        setShowMotOpportunityDialog(state, action: PayloadAction<boolean>) {
            state.showMotOpportunityDialog = action.payload
        },
        setMOTOpportunityDetail(state, action: PayloadAction<MotOpportunity>) {
            state.loadingMotOpportunityDetail = false
            // set MOT OpportunityDetails Edit mode

            state.motOpportunityDetail = action.payload
        },
        setSavingMOTOpportunity(state, action: PayloadAction<boolean>) {
            state.savingMOTOpportunity = action.payload
        },
        // setshowSuccessToastr(state, action: PayloadAction<boolean>) {
        //     state.showSucessToastr = action.payload
        // },
        // setshowErrorToastr(state, action: PayloadAction<[boolean, ErrorMessage | null]>) {
        //     state.showErrorToastr = action.payload[0]
        //     state.errorMessage = action.payload[1]
        // },
    },
})

export const {
    setOpportunityGridLoader,
    setShowMotOpportunityDialog,
    setMOTOpportunityDetail,
    setSavingMOTOpportunity,
    // setshowSuccessToastr,
    // setshowErrorToastr,
    getMotOpportunityDetail,
} = activitySlice.actions

export default activitySlice.reducer
export const fetchMotOpportunityDetail =
    (selectedDealerId: number): AppThunk =>
    (dispatch: any, getState) => {
        dispatch(setOpportunityGridLoader(true))
        // dispatch(showLoader(true))
        httpService(getAccessToken(getState()))
            .get(`regions/${getSelectedRegionId(getState())}/dealers/${selectedDealerId}/vehicle-mot-opportunities`)
            .then(res => {
                const opportunitiesData = res.data.map((data: any) => ({
                    ...data,
                    motExpiryDate: new Date(data.motExpiryDate),
                }))
                dispatch(getMotOpportunityDetail(opportunitiesData))
            })
            .catch((res: AxiosError) => {
                dispatch(
                    setToastr({
                        isActive: true,
                        message: res.response?.data as string,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: "",
                    }),
                )
            })
            .finally(() => dispatch(setOpportunityGridLoader(false)))
    }
export const addMOTOpportunity =
    (data: MotOpportunity): AppThunk =>
    (dispatch: any, getState) => {
        const dealerId = data.dealerID

        const motOpportunity = {
            ...data,
            motExpiryDate: dayjs(data.motExpiryDate).startOf("day").format("YYYY-MM-DD"),
            vehicleID: data.vehicleID > 0 ? data.vehicleID : null,
        }
        dispatch(setSavingMOTOpportunity(true))
        httpService(getAccessToken(getState()))
            .post(
                `regions/${getSelectedRegionId(getState())}/dealer/${dealerId}/vehicle-mot-opportunity`,
                motOpportunity,
            )
            .then(res => {
                dispatch(setSavingMOTOpportunity(false))
                dispatch(
                    setToastr({
                        isActive: true,
                        message: "MOT Opportunity details Saved",
                        delay: 3000,
                        title: "Success",
                        type: "light",
                        description: "",
                    }),
                )
                dispatch(setShowMotOpportunityDialog(false))
                dispatch(fetchMotOpportunityDetail(dealerId))
            })
            .catch((res: AxiosError) => {
                dispatch(
                    setToastr({
                        isActive: true,
                        message: res.response?.data as string,
                        delay: 3000,
                        title: "Error",
                        type: "danger",
                        description: "",
                    }),
                )

                dispatch(setSavingMOTOpportunity(false))
            })
    }

// #region Thunks
